import React from "react";
import {
  formatNumber,
  getDayOfDate,
  formatSimpleDate,
  getTitleDecoration,
} from "utils/common";

const Card = ({ pointItem }) => {
  return (
    <div className="card-layout my-2 my-md-0 px-3 px-md-0 py-2">
      <div className="row gx-0">
        <div className="w-col-9">
          <div className="row gx-0">
            <div className="col-12 col-md-10 align-items-center">
              {pointItem.promotion_name}
            </div>
            <div className="col-12 col-md-2 text-start text-md-center date-1">
              <span className="d-inline-block d-md-none me-1">
                ポイント確定日 :
              </span>
              {formatSimpleDate(pointItem.point_effective_date)}
              <span className="d-inline-block d-md-none">
                ({getDayOfDate(pointItem.point_effective_date)})
              </span>
            </div>
          </div>
        </div>
        <div className="w-col-3">
          <div className="row gx-0 text-center">
            <div className="col-12 col-md-5 col-border price text-center text-md-end">
              {formatNumber(pointItem?.point)}
              <div className="d-block d-md-none">ポイント</div>
            </div>
            <div className="text-layout col-12 col-md-7 date-2 fw-600">
              {formatSimpleDate(pointItem.expired_date)}
              <div className="d-block d-md-none">まで有効</div>
            </div>
          </div>
        </div>
      </div>
      {pointItem?.note && (
        <div className="row gx-0 px-2 my-2 remarks border-color-grey-light">
          備考：{pointItem?.note}
        </div>
      )}
    </div>
  );
};

export default Card;
